import React from 'react';

export const Section = ({
    children,
    label = ''
}) => {
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                <div style={{
                    flexGrow: '1',
                    fontSize: '1.1em',
                    fontWeight: '700',
                    textTransform: 'uppercase'
                }}>
                    {label}
                </div>
            </div>
            <div>
                {children}
            </div>
        </div>
    );
};
